import { render, staticRenderFns } from "./GenioIso.vue?vue&type=template&id=31d6f955&"
import script from "./GenioIso.vue?vue&type=script&lang=ts&"
export * from "./GenioIso.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports